export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-serif font-bold text-lg">
                谜
              </span>
              <span className="font-heading font-bold text-lg text-background-100">
                谜妹漫画
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              谜妹漫画提供韩漫、日漫、国漫分类大全，涵盖悬疑漫画、恋爱漫画、搞笑漫画等全类型，
              支持下拉式免费在线阅读，每日同步更新热门连载，满足不同口味的漫画爱好者。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '焦点专题', href: '#carousel' },
                { label: '热门话题', href: '#topics' },
                { label: '精选推荐', href: '#cards' },
                { label: '人气排行', href: '#ranking' },
              ].map((item) => (
                <li key={item.href}>
                  <a href={item.href} onClick={(e) => { e.preventDefault(); scrollTo(item.href); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">漫画分类</h4>
            <ul className="space-y-2.5">
              {['韩漫', '日漫', '国漫', '悬疑漫画', '恋爱漫画', '搞笑漫画'].map((item) => (
                <li key={item}>
                  <a href="#topics" onClick={(e) => { e.preventDefault(); scrollTo('#topics'); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              更多合作伙伴正在筹备中，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 谜妹漫画 - 韩漫日漫国漫分类大全。本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollTo('#about'); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }} className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
          </div>
        </div>
      </div>
    </footer>
  );
}